(function () {
  var root = document.documentElement;
  var body = document.body;
  if (!root || !body) return;

  var buttons = [].slice.call(
    document.querySelectorAll('.nm-theme-toggle,.nm-mobile-theme-toggle'),
  );

  function readTheme() {
    var stored = '';
    try {
      stored =
        localStorage.getItem('nmTheme') ||
        localStorage.getItem('nm-theme') ||
        '';
    } catch (error) {}
    if (stored === 'light' || stored === 'dark') return stored;
    var attr =
      root.getAttribute('data-nm-theme') ||
      root.getAttribute('data-theme') ||
      '';
    return attr === 'light' ? 'light' : 'dark';
  }

  function applyTheme(theme, persist) {
    var light = theme === 'light';
    root.setAttribute('data-nm-theme', theme);
    root.setAttribute('data-theme', theme);
    root.classList.toggle('nm-theme-light', light);
    root.classList.toggle('nm-theme-dark', !light);
    buttons.forEach(function (button) {
      button.setAttribute(
        'aria-label',
        light ? 'Activar modo oscuro' : 'Activar modo claro',
      );
      button.setAttribute(
        'title',
        light ? 'Activar modo oscuro' : 'Activar modo claro',
      );
      button.setAttribute('aria-pressed', light ? 'true' : 'false');
    });
    if (persist) {
      try {
        localStorage.setItem('nmTheme', theme);
        localStorage.setItem('nm-theme', theme);
      } catch (error) {}
    }
  }

  applyTheme(readTheme(), false);
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      var current =
        (root.getAttribute('data-nm-theme') ||
          root.getAttribute('data-theme')) === 'light'
          ? 'light'
          : 'dark';
      applyTheme(current === 'light' ? 'dark' : 'light', true);
    });
  });

  var navToggle = document.querySelector('.js-drawer-open-left');
  var leftDrawer = document.getElementById('NavDrawer');
  if (navToggle && leftDrawer) {
    var syncMenuLabel = function () {
      var opened = body.classList.contains('js-drawer-open-left');
      navToggle.setAttribute('aria-label', opened ? 'Cerrar menú' : 'Abrir menú');
    };
    var observer = new MutationObserver(syncMenuLabel);
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
    syncMenuLabel();
  }

  var searchButtons = [].slice.call(
    document.querySelectorAll('.nm-search-toggle,.nm-mobile-search-toggle'),
  );
  searchButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      requestAnimationFrame(function () {
        var input = document.querySelector(
          '#SearchModal input[type="search"],.modal--search input[type="search"],input[name="q"]',
        );
        if (input) input.focus({ preventScroll: true });
      });
    });
  });

  var closeDetails = function (exception) {
    document
      .querySelectorAll('.nm-fenix-nav__disclosure[open]')
      .forEach(function (detail) {
        if (detail !== exception) detail.removeAttribute('open');
      });
  };
  document
    .querySelectorAll('.nm-fenix-nav__disclosure')
    .forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (detail.open) closeDetails(detail);
      });
    });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDetails();
  });
  body.addEventListener('click', function (event) {
    if (!event.target.closest('.nm-fenix-nav__disclosure')) closeDetails();
  });
})();

(function () {
  if (document.querySelector('[data-nm-cinematic-light]')) return;
  var body = document.body;
  var root = document.documentElement;
  if (!body || !root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var style = document.createElement('style');
  style.id = 'nm-cinematic-scroll-light-v01';
  style.textContent = '\
.nm-cinematic-light-field{--nm-cx:50vw;--nm-cy:52vh;--nm-angle:0deg;position:fixed;inset:0;z-index:34;pointer-events:none;overflow:hidden;mix-blend-mode:screen;contain:strict;opacity:.72;transition:opacity .3s ease}\
.nm-cinematic-light-field__orb,.nm-cinematic-light-field__wake{position:absolute;left:0;top:0;border-radius:50%;will-change:transform,opacity}\
.nm-cinematic-light-field__orb{width:min(68vw,860px);aspect-ratio:1;transform:translate3d(var(--nm-cx),var(--nm-cy),0) translate(-50%,-50%);background:radial-gradient(circle,rgba(199,251,255,.16) 0%,rgba(70,221,255,.13) 16%,rgba(20,126,255,.09) 35%,rgba(9,65,181,.035) 55%,transparent 72%);filter:blur(8px);opacity:.48;transition:opacity .28s ease}\
.nm-cinematic-light-field__wake{width:min(36vw,440px);height:115vh;transform:translate3d(var(--nm-cx),var(--nm-cy),0) translate(-50%,-50%) rotate(var(--nm-angle));background:linear-gradient(180deg,transparent 3%,rgba(51,211,255,.02) 20%,rgba(85,225,255,.14) 49%,rgba(24,117,255,.05) 70%,transparent 96%);filter:blur(34px);opacity:.12;transition:opacity .24s ease}\
.nm-cinematic-light-field.is-travelling .nm-cinematic-light-field__orb{opacity:.82}.nm-cinematic-light-field.is-travelling .nm-cinematic-light-field__wake{opacity:.42}\
html[data-nm-theme="light"] .nm-cinematic-light-field,html[data-theme="light"] .nm-cinematic-light-field{mix-blend-mode:soft-light;opacity:.32}\
@media(max-width:720px){.nm-cinematic-light-field{opacity:.5}.nm-cinematic-light-field__orb{width:105vw}.nm-cinematic-light-field__wake{width:66vw;opacity:.09}}\
@media(prefers-reduced-motion:reduce){.nm-cinematic-light-field{opacity:.32}.nm-cinematic-light-field__wake{display:none}.nm-cinematic-light-field__orb{width:90vw;transform:translate3d(50vw,48vh,0) translate(-50%,-50%)}}';
  document.head.appendChild(style);

  var field = document.createElement('div');
  field.className = 'nm-cinematic-light-field';
  field.setAttribute('data-nm-cinematic-light', '');
  field.setAttribute('aria-hidden', 'true');
  field.innerHTML =
    '<i class="nm-cinematic-light-field__orb"></i><i class="nm-cinematic-light-field__wake"></i>';
  body.appendChild(field);
  if (reduce) return;

  var fine = window.matchMedia('(pointer:fine)').matches;
  var pointerX = null;
  var pointerY = null;
  var lastY = window.scrollY;
  var scrollTimer = 0;
  var raf = 0;

  var update = function () {
    raf = 0;
    var doc = document.documentElement;
    var max = Math.max(1, doc.scrollHeight - window.innerHeight);
    var progress = Math.max(0, Math.min(1, window.scrollY / max));
    var baseX =
      window.innerWidth * (0.5 + Math.sin(progress * Math.PI * 2.15) * 0.14);
    var baseY =
      window.innerHeight * (0.5 + Math.cos(progress * Math.PI * 1.55) * 0.06);
    if (fine && pointerX !== null) {
      baseX = baseX * 0.76 + pointerX * 0.24;
      baseY = baseY * 0.84 + pointerY * 0.16;
    }
    var dy = window.scrollY - lastY;
    var angle = Math.max(-9, Math.min(9, dy * 0.12));
    lastY = window.scrollY;
    field.style.setProperty('--nm-cx', baseX.toFixed(1) + 'px');
    field.style.setProperty('--nm-cy', baseY.toFixed(1) + 'px');
    field.style.setProperty('--nm-angle', angle.toFixed(2) + 'deg');
  };

  var queue = function () {
    if (raf) return;
    raf = requestAnimationFrame(update);
  };
  var travelling = function () {
    field.classList.add('is-travelling');
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      field.classList.remove('is-travelling');
    }, 170);
    queue();
  };

  window.addEventListener('scroll', travelling, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  if (fine) {
    window.addEventListener(
      'pointermove',
      function (event) {
        pointerX = event.clientX;
        pointerY = event.clientY;
        queue();
      },
      { passive: true },
    );
  }
  update();
})();

/* FÉNIX R07.99 — BRAND MIRROR + LIVE CHAT SIGNAL */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  if (!root || !body) return;
  if (root.dataset.fnxR0799Ready === '1') return;
  root.dataset.fnxR0799Ready = '1';

  var reduceQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  var reduced = !!(reduceQuery && reduceQuery.matches);

  var style = document.createElement('style');
  style.id = 'fnx-r0799-brand-chat-style';
  style.textContent = '\
.site-header .nm-fenix-brand{position:relative!important;isolation:isolate;overflow:hidden;border-radius:16px;--fnx-logo-sheen-alpha:.88}\
.site-header .nm-fenix-brand::after{content:"";position:absolute;top:-58%;bottom:-58%;left:-44%;z-index:8;width:24%;pointer-events:none;opacity:0;background:linear-gradient(105deg,transparent 0%,rgba(182,239,255,.06) 18%,rgba(239,253,255,.74) 46%,rgba(83,222,255,.31) 62%,transparent 100%);transform:skewX(-18deg);mix-blend-mode:screen}\
.site-header .nm-fenix-brand.is-fnx-logo-sheen{--fnx-logo-sheen-alpha:.88}.site-header .nm-fenix-brand.is-fnx-logo-idle{--fnx-logo-sheen-alpha:.34}\
.site-header .nm-fenix-brand.is-fnx-logo-sheen::after,.site-header .nm-fenix-brand.is-fnx-logo-idle::after{animation:fnx-r0799-logo-mirror .48s cubic-bezier(.16,1,.3,1) 1}\
.site-header .nm-fenix-brand.is-fnx-logo-sheen .nm-fenix-brand__mark{animation:fnx-r0799-logo-glow .5s cubic-bezier(.16,1,.3,1) 1}\
.site-header .nm-fenix-brand:hover .nm-fenix-brand__mark,.site-header .nm-fenix-brand:focus-visible .nm-fenix-brand__mark{filter:drop-shadow(0 0 20px rgba(20,201,255,.48)) drop-shadow(0 0 34px rgba(47,114,255,.18))}\
@keyframes fnx-r0799-logo-mirror{0%{left:-44%;opacity:0}18%{opacity:var(--fnx-logo-sheen-alpha)}68%{opacity:calc(var(--fnx-logo-sheen-alpha) * .82)}100%{left:120%;opacity:0}}\
@keyframes fnx-r0799-logo-glow{0%,100%{filter:drop-shadow(0 0 12px rgba(20,201,255,.16))}48%{filter:drop-shadow(0 0 26px rgba(20,201,255,.62)) drop-shadow(0 0 42px rgba(47,114,255,.28))}}\
html[data-nm-theme="light"] .site-header .nm-fenix-brand::after,html[data-theme="light"] .site-header .nm-fenix-brand::after{background:linear-gradient(105deg,transparent 0%,rgba(35,137,210,.04) 18%,rgba(255,255,255,.94) 47%,rgba(39,184,225,.22) 63%,transparent 100%);mix-blend-mode:normal}\
.fnx-live-chat-signal{position:fixed;z-index:2147482990;display:none;align-items:center;gap:7px;min-height:25px;padding:5px 9px;color:#dffaff;border:1px solid rgba(101,224,255,.36);border-radius:999px;background:linear-gradient(145deg,rgba(4,25,55,.92),rgba(6,45,88,.90));box-shadow:0 10px 28px rgba(0,5,26,.28),0 0 18px rgba(20,201,255,.09),inset 0 1px rgba(224,250,255,.10);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);pointer-events:none;white-space:nowrap;font:800 9px/1 Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;letter-spacing:.14em;text-transform:uppercase;transform:translateZ(0)}\
.fnx-live-chat-signal.is-visible{display:flex}\
.fnx-live-chat-signal__dot{display:block;width:7px;height:7px;flex:0 0 7px;border-radius:50%;background:#55dcff;box-shadow:0 0 0 0 rgba(85,220,255,.28),0 0 11px rgba(85,220,255,.82);animation:fnx-r0799-live-pulse 2.25s ease-in-out infinite}\
@keyframes fnx-r0799-live-pulse{0%,100%{opacity:1;transform:scale(1);box-shadow:0 0 0 0 rgba(85,220,255,.30),0 0 11px rgba(85,220,255,.82)}50%{opacity:.48;transform:scale(.78);box-shadow:0 0 0 5px rgba(85,220,255,0),0 0 6px rgba(85,220,255,.34)}}\
html[data-nm-theme="light"] .fnx-live-chat-signal,html[data-theme="light"] .fnx-live-chat-signal{color:#0a4f7f;border-color:rgba(14,131,193,.25);background:linear-gradient(145deg,rgba(255,255,255,.96),rgba(224,242,255,.94));box-shadow:0 9px 24px rgba(31,87,143,.14),inset 0 1px #fff}\
@media(max-width:620px){.fnx-live-chat-signal{min-height:24px;padding:5px 8px;font-size:8px;letter-spacing:.13em}}\
@media(prefers-reduced-motion:reduce){.site-header .nm-fenix-brand::after{display:none!important}.site-header .nm-fenix-brand.is-fnx-logo-sheen .nm-fenix-brand__mark,.site-header .nm-fenix-brand.is-fnx-logo-idle .nm-fenix-brand__mark,.fnx-live-chat-signal__dot{animation:none!important}.fnx-live-chat-signal__dot{opacity:1!important;transform:none!important}}';
  document.head.appendChild(style);

  function initBrandEffect() {
    var brand = document.querySelector('.site-header .nm-fenix-brand');
    if (!brand || brand.dataset.fnxMirrorReady === '1') return;
    brand.dataset.fnxMirrorReady = '1';
    if (reduced) return;

    var resetTimer = 0;
    function play(idle) {
      brand.classList.remove('is-fnx-logo-sheen', 'is-fnx-logo-idle');
      void brand.offsetWidth;
      brand.classList.add(idle ? 'is-fnx-logo-idle' : 'is-fnx-logo-sheen');
      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(function () {
        brand.classList.remove('is-fnx-logo-sheen', 'is-fnx-logo-idle');
      }, 560);
    }

    brand.addEventListener(
      'pointerdown',
      function () {
        play(false);
      },
      { passive: true },
    );
    brand.addEventListener('click', function () {
      try {
        sessionStorage.setItem('fnxLogoArrivalR0799', '1');
      } catch (error) {}
    });
    brand.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') play(false);
    });

    var arriving = false;
    try {
      arriving = sessionStorage.getItem('fnxLogoArrivalR0799') === '1';
      if (arriving) sessionStorage.removeItem('fnxLogoArrivalR0799');
    } catch (error) {}
    if (arriving) window.setTimeout(function () { play(false); }, 90);

    window.setInterval(function () {
      if (
        document.visibilityState === 'visible' &&
        !brand.matches(':hover') &&
        !brand.matches(':focus-visible')
      ) {
        play(true);
      }
    }, 10000);
  }

  initBrandEffect();
  var staleSignal = document.getElementById('fnxLiveChatSignal');
  if (staleSignal) staleSignal.remove();
})();

/* FÉNIX R08.06 — RECOMMENDATION FEATURED CARD LINK */
(function () {
  'use strict';
  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;
      var card = event.target.closest('[data-r07-related-card].is-featured');
      if (!card || event.target.closest('a')) return;
      var url = card.getAttribute('data-r07-product-url');
      if (!url) return;
      event.preventDefault();
      event.stopPropagation();
      var destination = url;
      if (
        window.Shopify &&
        Shopify.theme &&
        Shopify.theme.role === 'unpublished' &&
        Shopify.theme.id
      ) {
        var previewUrl = new URL(url, window.location.origin);
        previewUrl.searchParams.set('preview_theme_id', String(Shopify.theme.id));
        destination = previewUrl.href;
      }
      window.location.assign(destination);
    },
    true
  );
})();

/* FÉNIX R07.100 — MOBILE LOGO RESTORE / SAFARI COMPOSITING GUARD */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root || root.dataset.fnxR07100Ready === '1') return;
  root.dataset.fnxR07100Ready = '1';

  var style = document.createElement('style');
  style.id = 'fnx-r07100-mobile-logo-guard';
  style.textContent = '\
@media(max-width:620px){\
html body .site-header .nm-header__logo-wrap,html body .site-header .site-header__logo{display:block!important;visibility:visible!important;opacity:1!important;min-width:0!important;overflow:visible!important}\
html body .site-header .nm-fenix-brand{display:block!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;position:relative!important;z-index:3!important;isolation:auto!important;overflow:visible!important;border-radius:0!important;background-repeat:no-repeat!important;background-position:left center!important;background-size:contain!important;transform:none!important}\
html body .site-header .nm-fenix-brand::after{display:none!important}\
html body .site-header .nm-fenix-brand.is-fnx-logo-sheen{animation:fnx-r07100-mobile-logo-glow .48s cubic-bezier(.16,1,.3,1) 1}\
html body .site-header .nm-fenix-brand.is-fnx-logo-idle{animation:fnx-r07100-mobile-logo-idle .48s cubic-bezier(.16,1,.3,1) 1}\
}\
@keyframes fnx-r07100-mobile-logo-glow{0%,100%{opacity:1}48%{opacity:.86}}\
@keyframes fnx-r07100-mobile-logo-idle{0%,100%{opacity:1}48%{opacity:.94}}\
@media(prefers-reduced-motion:reduce){html body .site-header .nm-fenix-brand{animation:none!important}}';
  document.head.appendChild(style);
})();
